export const auctionDetailsStyle = {
  wrapper: {
    maxWidth: '970px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  tabs: {
    marginTop: '24px',
  },

  tab: {
    maxWidth: '477px',
    width: '100%',
    zIndex: 99,
  },

  title: {
    textAlign: 'center',
  },
};
